/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_LoadingInputs */

const en_invite_loading = /** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading invite`)
};

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const ar_invite_loading = en_invite_loading;

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const he_invite_loading = en_invite_loading;

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const ur_invite_loading = en_invite_loading;

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const es_invite_loading = en_invite_loading;

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const fr_invite_loading = en_invite_loading;

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const de_invite_loading = en_invite_loading;

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const pt_invite_loading = en_invite_loading;

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const hi_invite_loading = en_invite_loading;

/** @type {(inputs: Invite_LoadingInputs) => LocalizedString} */
const bn_invite_loading = en_invite_loading;

/**
* | output |
* | --- |
* | "Loading invite" |
*
* @param {Invite_LoadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_loading = /** @type {((inputs?: Invite_LoadingInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_LoadingInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_loading(inputs)
	if (locale === "he") return he_invite_loading(inputs)
	if (locale === "ur") return ur_invite_loading(inputs)
	if (locale === "es") return es_invite_loading(inputs)
	if (locale === "fr") return fr_invite_loading(inputs)
	if (locale === "de") return de_invite_loading(inputs)
	if (locale === "pt") return pt_invite_loading(inputs)
	if (locale === "hi") return hi_invite_loading(inputs)
	if (locale === "bn") return bn_invite_loading(inputs)
	return /** @type {LocalizedString} */ ("Loading invite")
});